<template>
  <div>
    <div>
      <ValidationObserver ref="loginForm" slim>
        <b-form @submit.prevent="send" class="clearfix mb-3">
          <ValidationProvider
              name="Agency name"
              :rules="{ required: true }"
              v-slot="vContext"
            >
            <b-form-group :label="$gettext('Agency name')" label-class="font-weight-bold pt-0" label-for="agency">
              <b-input
                type="text"
                name="agency"
                id="agency"
                v-model="register.agency"
                :placeholder="$gettext('Agency name')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="agency"
              />
              <b-form-invalid-feedback id="agency">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
              name="Unique registration code"
              :rules="{ required: true }"
              v-slot="vContext"
            >
            <b-form-group :label="$gettext('VAT no')" label-class="font-weight-bold pt-0" label-for="vat">
              <b-input
                type="text"
                name="Unique registration code"
                id="vat"
                v-model="register.vat"
                :placeholder="$gettext('VAT no')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="cui"
              />
              <b-form-invalid-feedback id="cui">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
              name="Cod registru comertului"
              :rules="{ required: true }"
              v-slot="vContext"
            >
            <b-form-group :label="$gettext('Company no')" label-class="font-weight-bold pt-0" label-for="regCom">
              <b-input
                type="text"
                name="regCom"
                id="regCom"
                v-model="register.regcom"
                :placeholder="$gettext('Company no')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="regCom"
              />
              <b-form-invalid-feedback id="regCom">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
            name="Email"
            :rules="{required: true}"
            v-slot="vContext"
          >
            <b-form-group :label="$gettext('Email')" label-class="font-weight-bold pt-0" label-for="email">
              <b-input
                type="email"
                name="email"
                id="email"
                v-model="register.email"
                :placeholder="$gettext('Email')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="email"
              />
              <b-form-invalid-feedback id="email">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
            name="Telefon"
            :rules="{required: true}"
            v-slot="vContext"
          >
            <b-form-group :label="$gettext('Phone')" label-class="font-weight-bold pt-0" label-for="telefon">
              <b-input
                type="text"
                name="telefon"
                id="telefon"
                v-model="register.phone"
                :placeholder="$gettext('Phone')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="phone"
              />
              <b-form-invalid-feedback id="phone">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
            name="Contact pearson"
            :rules="{required: true}"
            v-slot="vContext"
          >
            <b-form-group :label="$gettext('Name')" label-class="font-weight-bold pt-0" label-for="nume">
              <b-input
                type="text"
                name="nume"
                id="nume"
                v-model="register.name"
                :placeholder="$gettext('Contact person')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="agent_name"
              />
              <b-form-invalid-feedback id="agent_name">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
            name="persoana contact"
            :rules="{required: true}"
            v-slot="vContext"
          >
            <b-form-group :label="$gettext('Address')" label-class="font-weight-bold pt-0" label-for="address">
              <b-input
                type="text"
                name="adresa"
                id="adresa"
                v-model="register.address"
                :placeholder="$gettext('Agency address')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="address"
              />
              <b-form-invalid-feedback id="address">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <hr>
          <div class="clearfix">
            <b-button type="submit" variant="primary" class="btn-block">
              <translate>Send</translate>
            </b-button>
          </div>
          <hr>
          <small class="py-1">
            <router-link :to="{ name: 'Public/Login' }" class="link"> <translate>click here to login</translate></router-link>
          </small>
        </b-form>
      </ValidationObserver>
    </div>
    <b-modal id="success" hide-header hide-footer v-model="modalSuccess" centered>
      <template v-if="subscribeSuccess">
        <div class="d-flex align-item-center justify-content-center send-success">
          <div class="pt-4">
            <p class="d-flex align-item-center justify-content-center">
              <b-iconstack font-scale="5" animation="throb">
                <b-icon stacked icon="check2" variant="success" scale="0.75"></b-icon>
                <b-icon stacked icon="circle" variant="success"></b-icon>
              </b-iconstack>
            </p>
            <h4 class="text-center"><translate>The data was sent successfully!</translate></h4>
          </div>
        </div>
        <!-- <hr> -->
        <p class="my-4 text-center">
          <router-link :to="{ name: 'Public/Login' }" class="btn btn-warning">
            <b v-translate>Log in</b>
          </router-link>
        </p>
      </template>
      <template v-else>
        <div class="d-flex align-item-center justify-content-center send-fail">
          <div class="pt-4">
            <p class="d-flex align-item-center justify-content-center">
              <b-icon icon="slash-circle" animation="throb" font-scale="8" class="text-danger"></b-icon>
            </p>
            <h5 class="text-center"><translate>We apologize, there was an error in transmitting the data.</translate><br/><translate>Please try again or contact us.</translate></h5>
          </div>
        </div>
        <hr>
        <p class="my-4 text-center">
          <b-button @click="closeModal" variant="primary"> <b v-translate>Close</b> </b-button>
        </p>
      </template>
    </b-modal>
  </div>
</template>

<script>
import validation from 'b2b-common/mixins/validation'
import { register } from 'b2b-common/services/public'
import toast from 'b2b-common/mixins/toast'

export default {
  name: 'Subscribe',
  mixins: [validation, toast],
  data () {
    return {
      register: {
        agency: '',
        vat: '',
        regcom: '',
        email: '',
        phone: '',
        name: '',
        address: ''
      },
      subscribeSuccess: true,
      modalSuccess: false
    }
  },
  methods: {
    send () {
      this.$refs.loginForm.validate().then(success => {
        if (!success) {
          this.addToast({
            title: this.$gettext('Invalid form'),
            message: this.$gettext('Please fill in all required fields!'),
            variant: 'danger'
          })
        } else {
          register(this.register).then(res => {
            if (res !== 'OK') this.subscribeSuccess = false
            this.modalSuccess = true
          })
        }
      })
    },
    closeModal () {
      this.modalSuccess = false
    }
  }
}
</script>
<style scoped>
  .send-success{
    border: 2px solid rgba(0,128,0,.5);
    border-radius:5px;
    background-color: rgba(226,249,224,.35);
  }
  .send-fail{
    border: 2px solid rgba(185,0,0,.5);
    border-radius:5px;
    background-color: rgba(230,196,1964,.35);
    padding: 0 1rem 1rem;
  }
</style>
